import {
    TRANSACTION_REPORT_SUCCESS,
    TRANSACTION_REPORT_FAILED,
    TRANSACTION_REPORT_INVALID_REQUEST,
    TRANSACTION_REPORT_NOT_FOUND,
    TRANSACTION_REPORT_EMAIL_NOT_FOUND,
    LOADING_TRANSACTION_REPORT,
    RESET_TRANSACTION_REPORT,
} from "../types";

const initialState = {
    isLoading: false,
    success: false,
    failed: false,
    invalidRequest: false,
    notFound: false,
    emailNotFound: false,
    data: {},
    status: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_TRANSACTION_REPORT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: false,
                emailNotFound: false,
                data: {},
                status: ""
            };
        case TRANSACTION_REPORT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                invalidRequest: false,
                notFound: false,
                emailNotFound: false,
                data: action.payload,
                status: "Transaction Report Downloaded Successfully"
            };
        case TRANSACTION_REPORT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                invalidRequest: false,
                notFound: false,
                emailNotFound: false,
                data: action.payload,
                status: "Transaction Report Download Failed"
            };
        case TRANSACTION_REPORT_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: true,
                notFound: false,
                emailNotFound: false,
                data: action.payload,
                status: "Invalid Request"
            };
        case TRANSACTION_REPORT_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: true,
                emailNotFound: false,
                data: action.payload,
                status: "Transaction Report Not Found"
            };
        case TRANSACTION_REPORT_EMAIL_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                notFound: false,
                emailNotFound: true,
                data: action.payload,
                status: "Email Not Found"
            };
        case RESET_TRANSACTION_REPORT:
            return (state = initialState);

        default:
            return state;
    }
};